import { useRouter } from 'next/router';
export const useGoSignin = () => {
  const router = useRouter();
  return (shouldRedirectURL: boolean) => router.push({
    pathname: '/accounts/signin',
    query: {
      redirectURL: shouldRedirectURL ? router.asPath : undefined
    }
  });
};